const normalize_refs = (refs) => (
    (Array.isArray(refs) ? refs : [])
        .map((ref) => ({
            source: ref?.source,
            id: ref?.id != null ? String(ref.id).trim() : '',
            name: ref?.name,
        }))
        .filter((ref) => ref.id)
);

/**
 * Refs to show instead of the entity id.
 * A Kronos ref that only repeats the UUID is not a user-defined public id.
 */
const display_refs = (entityId, refs) => {
    const id = String(entityId || '');
    return normalize_refs(refs).filter((ref) => !(
        ref.source === 'kronos' && ref.id === id
    ));
};

const should_show_entity_id = (entityId, refs) => (
    Boolean(entityId) && display_refs(entityId, refs).length === 0
);

/**
 * Identifier to write in an import file: user Kronos ref, then any other ref, else the id.
 */
const preferred_public_id = (entityId, refs) => {
    const visible = display_refs(entityId, refs);
    const kronos = visible.find((ref) => ref.source === 'kronos');
    if (kronos)
        return kronos.id;
    if (visible.length)
        return visible[0].id;
    return entityId == null ? '' : String(entityId);
};

const entity_matches_id_or_ref = (entity, value) => {
    const needle = String(value ?? '').trim();
    if (!needle || !entity)
        return false;
    if (entity._id != null && String(entity._id) === needle)
        return true;
    return normalize_refs(entity.refs).some((ref) => ref.id === needle);
};

const find_pricing_key = (pricings, value) => {
    const needle = String(value ?? '').trim();
    if (!needle || !pricings || typeof pricings !== 'object')
        return null;
    if (Object.prototype.hasOwnProperty.call(pricings, needle))
        return needle;
    const key = Object.keys(pricings).find((pricingKey) => (
        normalize_refs(pricings[pricingKey]?.refs).some((ref) => ref.id === needle)
    ));
    return key || null;
};

export {
    display_refs,
    entity_matches_id_or_ref,
    find_pricing_key,
    preferred_public_id,
    should_show_entity_id,
};
